import { useMemo } from 'react';
import type { Question } from '@mentimeter/http-clients';
import { usePresentation as sharedUsePresentation } from '@mentimeter/presentation-state';
import { useAppSelector } from '../../redux-hooks';
import { paceModeSelector } from '../../selectors';

interface UseBulletProps {
  choices: Question['choices'];
  shouldShowAllBullets: boolean;
}
export const useBullets = ({
  choices,
  shouldShowAllBullets,
}: UseBulletProps) => {
  const presenterStep = sharedUsePresentation(
    (state) => state.state?.step ?? 0,
  );
  const paceMode = useAppSelector(paceModeSelector);
  const step =
    paceMode === 'audience' || shouldShowAllBullets
      ? choices.length
      : presenterStep;
  return useMemo(() => choices.slice(0, step), [choices, step]);
};
